module.exports = __webpack_public_path__ + "media/body-condition/skinny-633b5b01.svg";